import React from 'react'
import './styles.css'

function setCurrentDateToInput() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate
}

export default function DateRangePicker({ setFromDate, setToDate, onApplyDateFilter }) {

    const setBeginDate = (e) =>{
        const { value } = e.target
        setFromDate(value)
    }

    const setEndDate = (e) =>{
        const { value } = e.target
        setToDate(value)
    }

    return (
        <div className='date-range-picker'>
            <input type="date" className='date-rang-input' id="from" onChange={(e)=> setBeginDate(e)} defaultValue={setCurrentDateToInput()} name="from" />
            <input type="date" className='date-rang-input' defaultValue={setCurrentDateToInput()} id="to" onChange={(e)=> setEndDate(e)} name="to" />
            <a onClick={()=>  onApplyDateFilter()} className='aply-fltr-btn' href="#">Appliquer le filtre</a>
        </div>
    )
}
